/**
 * Every failure the admin can see, in one shape.
 *
 * `code` and `details` come straight from the api's error envelope
 * (`AllExceptionsFilter`), so a caller branches on the same string the server
 * emitted — `consent_required`, `invalid_refresh_token`, `validation_failed` —
 * rather than on an HTTP status that several causes share.
 *
 * Transport failures get `status: 0` and a synthetic code, because "the request
 * never reached the api" is a genuinely different thing from "the api refused
 * it" and a form that reports the second for the first sends the operator
 * looking for a field that is fine.
 */
export interface ApiError {
  /** HTTP status, or 0 when the request never completed. */
  status: number;
  /** The api's `error.code`, or `network` / `unknown` for a transport failure. */
  code: string;
  /** The api's envelope-level `message`, already localised by the server. */
  message: string;
  /** Field path → messages, present on `validation_failed` (422). */
  details?: Record<string, string[]>;
}

/** A failure that never reached the api at all. */
export const NETWORK_ERROR_CODE = 'network';
/** A response the admin could not make sense of. */
export const UNKNOWN_ERROR_CODE = 'unknown';
